import React, {Component} from 'react';
import checkBrandUserSession from 'js/brand_session';

export default class RequireBrandSession extends Component {
    constructor() {
        super();

        this.state = {
            validSession: false
        };
    }

    componentDidMount() {
        this.checkSession();
    }

    checkSession = async () => {
        try {
            await checkBrandUserSession();
            this.setState({validSession: true});
        } catch (error) {
            this.setState({error, validSession: false});
        }
    };

    render() {
        if (this.state.validSession) {
            return this.props.children;
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./require_brand_session.js